import { endpoints } from "@/configs/Settings";
import { auxiliarData } from "../AuxiliarData";
import { useAuth } from "@/utils/useAuth";
import { useAxios } from "@/utils/useAxios";
import { HTTPResponseStatus } from "@/utils/enum";
import { AffiliationFormData } from "@/pages/insuranceguide/components/AffiliationModal";
import * as uuid from "uuid";
export interface AffiliationReferences {
  defaultId?: string;
  prestadorId: string;
  prestadorDisplay: string;
}

export async function PutOrganizationAffiliation(
  affiliationFormData: AffiliationFormData,
  references: AffiliationReferences
) {
  const id = references.defaultId || uuid.v1();
  let url = `${endpoints.ADMFHIR}/OrganizationAffiliation`;

  if (id) {
    url = `${endpoints.ADMFHIR}/OrganizationAffiliation/${id}`;
  }

  const auxData = auxiliarData.OrganizationAffiliation(
    affiliationFormData,
    references
  );

  const data = JSON.stringify({
    ...auxData,
    id,
  });

  const headers = {
    Accept: "application/fhir+json",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
  };

  const response = await useAxios
    .put(url, data, { headers, timeout: 20000 })
    .then((response) => {
      if (
        response.status !== HTTPResponseStatus.Created &&
        response.status !== HTTPResponseStatus.Success
      ) {
        throw new Error(`PutOrganizationAffiliation: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("PutOrganizationAffiliation ", error);

      throw new Error();
    });
  if (response) return response;
}
